
export const getPaginatedGallery = () => 'company/gallery/paginated/'